import { PillTypeForToggleAnalytics } from '@confluence/premium-onboarding/entry-points/PremiumFeatureHighlightToggle';

type GetPillTypeProps = {
	hasBillingInformation: boolean;
	isSiteAdmin: boolean;
};

export const getPillType = ({ isSiteAdmin, hasBillingInformation }: GetPillTypeProps) => {
	return isSiteAdmin
		? hasBillingInformation
			? PillTypeForToggleAnalytics.HAS_PAYMENT
			: PillTypeForToggleAnalytics.NO_PAYMENT
		: PillTypeForToggleAnalytics.END_USER;
};
